/**
 * Replace a boolean value with a more user-friendly string. Does nothing if the
 * existing value was a string
 *
 * @param rawValue The value to convert.
 * @returns A user-friendly string representation of the value that was passed
 *   in.
 */
export function getPrettyValue(rawValue) {
    if (rawValue === true)
        return "Yes";
    if (rawValue === false)
        return "No";
    return rawValue;
}
//# sourceMappingURL=boolean.js.map